module.exports = __webpack_public_path__ + "img/Hordeum_vulgare.3a3892a3.jpg";